import { IsBoolean, IsOptional, IsString, MinLength, MaxLength, Matches } from 'class-validator';
import { Duplicates } from './duplicates';

export interface IPhone {
  phone: string;
  ext?: string;
}

export interface ICreateLinkedPhone {
  phone: string;
  ext?: string;
  isExtension?: boolean;
}

export interface ILinkedPhone extends ICreateLinkedPhone, Duplicates {
  id: number;
}

export class CreatePhoneDto implements IPhone {
  @IsString()
  @MinLength(5)
  @MaxLength(50)
  phone: string;

  @IsOptional()
  @IsString()
  @Matches(/^\d{1,20}$/)
  ext?: string;

  @IsOptional()
  @IsBoolean()
  isExtension?: boolean;
}

export class PhoneDto extends CreatePhoneDto {
  id: number;
}
// export interface IEmployeePhone {
//   phone: string;
//   ext: string;
// }
